/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetAllocationCategory } from './AssetAllocationCategory';
import {
    AssetAllocationCategoryFromJSON,
    AssetAllocationCategoryFromJSONTyped,
    AssetAllocationCategoryToJSON,
} from './AssetAllocationCategory';

/**
 * 
 * @export
 * @interface AssetAllocationOverrideItem
 */
export interface AssetAllocationOverrideItem {
    /**
     * 
     * @type {AssetAllocationCategory}
     * @memberof AssetAllocationOverrideItem
     */
    category: AssetAllocationCategory;
    /**
     * 
     * @type {number}
     * @memberof AssetAllocationOverrideItem
     */
    value: number;
}



/**
 * Check if a given object implements the AssetAllocationOverrideItem interface.
 */
export function instanceOfAssetAllocationOverrideItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function AssetAllocationOverrideItemFromJSON(json: any): AssetAllocationOverrideItem {
    return AssetAllocationOverrideItemFromJSONTyped(json, false);
}

export function AssetAllocationOverrideItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetAllocationOverrideItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': AssetAllocationCategoryFromJSON(json['category']),
        'value': json['value'],
    };
}

export function AssetAllocationOverrideItemToJSON(value?: AssetAllocationOverrideItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': AssetAllocationCategoryToJSON(value.category),
        'value': value.value,
    };
}

